define('plugin/paid-attributes/view/step/AttributeItemView',['require','plugin/product/view/ProductItemView','lib/theme/ThemeSettings'],function (require) {

    var ProductItemView = require('plugin/product/view/ProductItemView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Attribute item view
     *
     * @class AttributeItemView
     */
    return ProductItemView.extend({

        modelEvents: {
            'change': 'safeRender'
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#paid_attribute_step_item_view_list';
            }
            return '#paid_attribute_step_item_view';
        },
        
        serializeData: function () {
            return _.extend({}, ProductItemView.prototype.serializeData.apply(this), {
                hide_duration: this.getOption('hide_duration')
            });
        }

    });

});
